import { render } from "./IconPinterest.vue?vue&type=template&id=e866c04c"
import script from "./IconPinterest.vue?vue&type=script&lang=js"
export * from "./IconPinterest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__